<div class="flex flex-col h-full w-full">
	<ng-content></ng-content>
</div>
